module.exports = __webpack_public_path__ + "files/fa5c355bf5e84b59b1157d8597cd5b65.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/mattermost_dark.png
// module id = 584
// module chunks = 60